/**
 * THE chevron-down glyph — the "Location picker" disclosure chevron in the
 * ZIP Code trigger (`molecules/zip-code`), and the Dropdown atom's own
 * affordance. Follows `close-glyph.ts`'s pattern: constants, not a component.
 * `fill="currentColor"` at every call site. The call site rotates it 180deg
 * when its control is expanded — the asset itself is not two glyphs.
 *
 * ⚠ THIS IS NOT AN ICON LAYER — see close-glyph.ts's header for what that
 * means. A further asset still has to make its own argument.
 *
 * FUSION ECLIPSE `down control` (`57e82e6c1d608b7388202dead80c07fbd75f0b04`),
 * local node `15829:51611` in `FDnUrbSC3dd0XIk5zNQmAR` — the "ZIP code
 * change" instance `I13337:12723;15133:24402`. 24x24, Figma fill
 * `#F4F7FC` dropped for `currentColor`.
 */
export const CHEVRON_DOWN_GLYPH_VIEWBOX = "0 0 24 24";

export const CHEVRON_DOWN_GLYPH_PATH =
  "M4.43925 9.59828C4.11948 9.27848 4.11964 8.75932 4.43925 8.43942L4.50175 " +
  "8.38278C4.80183 8.13858 5.23477 8.13878 5.53496 8.38343L5.59746 " +
  "8.43942L11.6665 14.5091L17.7355 8.44007C18.0353 8.14022 18.5101 8.12178 " +
  "18.8318 8.38408L18.8943 8.44007C19.1937 8.73983 19.2125 9.21407 18.9503 " +
  "9.53578L18.8943 9.59828L12.2641 16.2285C12.1007 16.3917 11.8863 16.4682 " +
  "11.6769 16.4661L11.6775 16.4668C11.6694 16.467 11.6609 16.4667 11.6528 " +
  "16.4668C11.4441 16.4679 11.2315 16.3903 11.0695 16.2285L4.43925 9.59828Z";
